import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { GenericService } from './generic.service';


@Injectable({
  providedIn: 'root'
})
export class WebsocketService {

  private socket: Socket;
  url = "https://api.anikinitek.com"

  constructor(
    private generic_service: GenericService
  ) {
    this.socket = io(this.url, { autoConnect: false, path: "/notifier/socket", transports: ["websocket"] });
    if (sessionStorage.getItem('token')) {
      this.socketConnection();
    }

    this.socket.on("connect", () => {
      console.log("Websocket connected successfully to:", this.url);
    });

    this.socket.on("connect_error", (error) => {
      console.error("Websocket connection error:", error.message || error);
    });

    this.socket.on("disconnect", (reason) => {
      console.warn("Websocket disconnected. Reason:", reason);
    });

    this.socket.onAny((event, ...args) => {
      console.log(event, args);

    });

    this.socket.on("TASK_ASSIGNED", (message) => {
      this.generic_service.notification.next('refresh');
    });

    this.socket.on("TICKET_NOTES", (message) => {

      this.generic_service.notification.next('refresh');

    });

    this.socket.on("TICKET_NEW", (message) => {
      this.generic_service.notification.next('refresh');
    });

    this.socket.on("TASK_NEW", (message) => {
      this.generic_service.notification.next('refresh');
    });

    this.socket.on("TASK_CREATED", (message) => {
      this.generic_service.notification.next('refresh');
    });

    this.socket.on("TASK_UPDATED", (message) => {
      this.generic_service.notification.next('refresh');
    });

    this.socket.on("TICKET_CREATED", (message) => {
      this.generic_service.notification.next('refresh');
    });

    this.socket.on("TICKET_UPDATED", (message) => {
      this.generic_service.notification.next('refresh');
    });

    this.socket.on("ASSET_ASSIGNED", (message) => {
      this.generic_service.notification.next('refresh');
    });

    this.socket.on("TRANSIT_REQUESTED", (message) => {
      this.generic_service.notification.next('refresh');
    });

    this.socket.on("TRANSIT_APPROVED", (message) => {
      this.generic_service.notification.next('refresh');
    });

    this.socket.on("TRANSIT_REJECTED", (message) => {
      this.generic_service.notification.next('refresh');
    });

    this.socket.on("TRANSIT_COMPLETED", (message) => {
      this.generic_service.notification.next('refresh');
    });




    this.socket.on("ALLOCATION_REQUESTED", (message) => {
      this.generic_service.notification.next('refresh');
    });

    this.socket.on("ALLOCATION_APPROVED", (message) => {
      this.generic_service.notification.next('refresh');
    });

    this.socket.on("ALLOCATION_DECLINED", (message) => {
      this.generic_service.notification.next('refresh');
    });

    this.socket.on("ALLOCATION_ISSUED", (message) => {
      this.generic_service.notification.next('refresh');
    });

    this.socket.on("ALLOCATION_STATUS_UPDATED", (message) => {
      this.generic_service.notification.next('refresh');
    });

    this.socket.on("INFO", (message) => {
      this.generic_service.notification.next('refresh');
    });
  }

  socketConnection() {
    this.socket.auth = { token: sessionStorage.getItem('token') };
    this.socket.connect();
    console.log("Attempting socket connection to:", this.url);
  }

  socketC(type: any, from: any, to: any, message: any) {
    this.socket.emit(type, {
      from: from,
      to: to,
      message: message
    });
  }


  socketDisconnect() {
    this.socket.disconnect();
  }

}